<template>
	<v-snackbar
		v-if="count"
		v-model="value"
		:color="current.color || 'secondary'"
		:timeout="6000"
		@click.native="value = false"
	>
		{{ current.message }}
		&nbsp;&nbsp;&nbsp;
		<div v-if="count > 1">(+{{ (count - 1) }})</div>
	</v-snackbar>
</template>

<script>
export default {
	props: {
		notifier: {
			type: Object
		}
	},
	data() {
		return {
			value: false,
			notificationStack: []
		};
	},
	computed: {
		count() {
			return this.notificationStack.length;
		},
		current() {
			return this.notificationStack[0];
		}
	},
	watch: {
		notifier(newNotification) {
			this.notificationStack.push(newNotification);
			this.value = true;
		},
		value(newValue) {
			if (newValue == false && this.count != 0) {
				this.notificationStack.shift();
				setTimeout(() => {
					this.value = true;
				}, 500);
			}
		}
	}
};
</script>

